export default "__VITE_ASSET__DMOgVaku__"